<template>
  <div>
    <v-flex pa-3>
      <v-layout row wrap justify-end>
        <v-flex class="subheading font-weight-bold mt-2 mb-2 px-3">
          {{ $t("descargasDesc") }}
        </v-flex>
        <v-flex shrink text-xs-right>
          <v-btn @click="fVolverAtras()" class="datSecondaryBtn" flat>Atrás</v-btn>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-center>
        <template v-for="item in dBtns">
          <v-flex text-xs-center shrink class="my-3" :key="item.filtro" v-if="fCheckBtns(item.filtro)">
            <v-btn class="datSecondaryBtn" flat tile @click="fDescargarDocumentos(item)">{{ item.btnText }}</v-btn>
          </v-flex>
        </template>
      </v-layout>
    </v-flex>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dBtns: {
        albaran: {
          'btnText': this.$t('albaranBtn'),
          'tipo': 'albaran',
          'filtro': 'A'
        },
        docId: {
          'btnText': this.$t('docIdBtn'),
          'tipo': 'docid',
          'filtro': 'DI'
        },
        tickets: {
          'btnText': this.$t('ticketImg'),
          'tipo': 'ticket',
          'filtro': 'TK'
        },
        ticket: {
          'btnText': this.$t('ticketBtn'),
          'tipo': 'ticket',
          'filtro': 'T'
        },
        fotografias: {
          'btnText': this.$t('fotoBtn'),
          'tipo': 'foto',
          'filtro': 'F'
        },
        documentAdj: {
          'btnText': this.$t('docAdj'),
          'tipo': 'documentos',
          'filtro': 'DOC'
        },
        todas: {
          'btnText': this.$t('todosBtn'),
          'tipo': 'all',
          'filtro': 'TO'
        }
      },
      dDatosUrlsItems: {
        'urlAlbaran': '',
        'urlsDI': [],
        'urlTicket': '',
        'urlFotografia': '',
        'urlsAdjClob': [],
        'urlsAdjUrl': [],
        'ticket': '',
      }
    }
  },
  mounted() {
    this.fPrepareURLS()
  },
  props: {
    pPedidoSeleccionado: {
      type: Object,
      required: true,
      default: null
    },
    pUrlsInformes: {
      type: Array,
      required: true,
      default: null
    }
  },
  methods: {
    fVolverAtras() {
      this.$emit('cerrar')
    },
    fDescargarDocumentos(item) {
      switch (item.filtro) {
        case 'A':
          window.open(this.dDatosUrlsItems.urlAlbaran, '_blank')
          break
        case 'DI':
          this.dDatosUrlsItems.urlsDI.forEach(item => {
            window.open(item.url, '_blank')
          })
          break
        case 'TK':
          window.open(this.dDatosUrlsItems.urlTicket, '_blank')
          break
        case 'T':
          window.open(this.dDatosUrlsItems.ticket, '_blank')
          break
        case 'F':
          window.open(this.dDatosUrlsItems.urlFotografia, '_blank')
          break
        case 'DOC':
          if (this.fCheckValid(this.dDatosUrlsItems.urlsAdjUrl)) {
            this.dDatosUrlsItems.urlsAdjUrl.forEach(urlAdj => {
              window.open(urlAdj, '_blank')
            })
          }
          if (this.fCheckValid(this.dDatosUrlsItems.urlsAdjClob)) {
            this.dDatosUrlsItems.urlsAdjClob.forEach(urlAdj => {
              var dataURI = 'data:application/pdf;base64,' + urlAdj
              window.open(dataURI)
            })
          }
          break
        case 'TO':
          if (this.fCheckValid(this.dDatosUrlsItems.urlAlbaran)) {
            window.open(this.dDatosUrlsItems.urlAlbaran, '_blank')
          }
          if (this.dDatosUrlsItems.urlsDI.length > 0) {
            this.dDatosUrlsItems.urlsDI.forEach(item => {
              window.open(item.url, '_blank')
            })
          }

          if (this.fCheckValid(this.dDatosUrlsItems.urlTicket)) {
            window.open(this.dDatosUrlsItems.urlTicket, '_blank')
          }

          if (this.fCheckValid(this.dDatosUrlsItems.ticket)) {
            window.open(this.dDatosUrlsItems.ticket, '_blank')
          }

          if (this.fCheckValid(this.dDatosUrlsItems.urlFotografia)) {
            window.open(this.dDatosUrlsItems.urlFotografia, '_blank')
          }

          if (this.fCheckValid(this.dDatosUrlsItems.urlsAdjUrl)) {
            this.dDatosUrlsItems.urlsAdjUrl.forEach(urlAdj => {
              window.open(urlAdj, '_blank')
            })
          }
          if (this.fCheckValid(this.dDatosUrlsItems.urlsAdjClob)) {
            this.dDatosUrlsItems.urlsAdjClob.forEach(urlAdj => {
              var dataURI = 'data:application/pdf;base64,' + urlAdj
              window.open(dataURI)
            })
          }
          break
      }
    },
    fPrepareURLS() {
      let encAlbaran = false
      let encFotosTicket = false
      let encFotografia = false
      let encDocAdjClob = false
      let encDocAdjUrls = false
      let encTicket = false

      this.pUrlsInformes.forEach(item => {
        if (this.fCheckValid(item.URLdi)) {
          this.dDatosUrlsItems.urlsDI.push({ 'url': item.URLdi })
        }
        if (!encAlbaran && this.fCheckValid(item.URLalbaran)) {
          this.dDatosUrlsItems.urlAlbaran = item.URLalbaran
          encAlbaran = true
        }
        if (!encFotosTicket && this.fCheckValid(item.URLticket)) {
          this.dDatosUrlsItems.urlTicket = item.URLticket
          encFotosTicket = true
        }
        if (!encTicket && this.fCheckValid(item.Ticket)) {
          this.dDatosUrlsItems.ticket = item.Ticket
          encTicket = true
        }
        if (!encFotografia && this.fCheckValid(item.URLfotoPDA)) {
          this.dDatosUrlsItems.urlFotografia = item.URLfotoPDA
          encFotografia = true
        }
        if (!encDocAdjClob && this.fCheckValid(item.DocAdjuntosClob)) {
          this.dDatosUrlsItems.urlsAdjClob = item.DocAdjuntosClob
          encDocAdjClob = true
        }
        if (!encDocAdjUrls && this.fCheckValid(item.DocAdjuntosURL)) {
          this.dDatosUrlsItems.urlsAdjUrl = item.DocAdjuntosURL
          encDocAdjUrls = true
        }
      })
    },
    fCheckValid(value) {
      let finalvalue = false;
      if (value !== undefined && value !== '' && value !== null) {
        finalvalue = true;
      } 
      return finalvalue;
    },
    fCheckBtns(filtro) {
      switch (filtro) {
        case 'A':
          if (this.dDatosUrlsItems.urlAlbaran !== '') {
            return true
          }
          break
        case 'DI':
          if (this.dDatosUrlsItems.urlsDI.length > 0) {
            return true
          }
          break
        case 'TK':
          if (this.dDatosUrlsItems.urlTicket !== '') {
            return true
          }
          break
        case 'T':
          if (this.dDatosUrlsItems.ticket !== '') {
            return true
          }
          break
        case 'F':
          if (this.dDatosUrlsItems.urlFotografia !== '') {
            return true
          }
          break
        case 'DOC':
          if (this.dDatosUrlsItems.urlsAdjClob.length > 0 || this.dDatosUrlsItems.urlsAdjUrl.length > 0) {
            return true
          }
          break
        case 'TO':
          return true
      }
      return false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/EstadoRecogidas/ShpFiltroRecEntrDescargas.vue